import { render, staticRenderFns } from "./CreateProject.vue?vue&type=template&id=5808eb29&scoped=true&"
import script from "./CreateProject.vue?vue&type=script&lang=js&"
export * from "./CreateProject.vue?vue&type=script&lang=js&"
import style0 from "./CreateProject.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./CreateProject.vue?vue&type=style&index=1&id=5808eb29&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5808eb29",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5808eb29')) {
      api.createRecord('5808eb29', component.options)
    } else {
      api.reload('5808eb29', component.options)
    }
    module.hot.accept("./CreateProject.vue?vue&type=template&id=5808eb29&scoped=true&", function () {
      api.rerender('5808eb29', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/projects/CreateProject.vue"
export default component.exports